export const CANONS_VELOCITY_X = {
  s: {
    min: 3,
    max: 6,
  },
  m: {
    min: 4,
    max: 8,
  },
  l: {
    min: 8,
    max: 16,
  },
  xl: {
    min: 9,
    max: 18,
  },
};

export const CANONS_VELOCITY_Y = {
  s: {
    min: -12,
    max: -24,
  },
  m: {
    min: -12,
    max: -24,
  },
  l: {
    min: -14,
    max: -28,
  },
  xl: {
    min: -14,
    max: -28,
  },
};
